import React, {useEffect} from 'react';
import {connect} from "react-redux";
import { useTranslation } from 'react-i18next';
import CommentsList from './components/comments-list';
import ContactDetails from './components/contact-details';
import SharingSettings from './components/sharing-settings';
import {addToOtherLabel, contactContent} from '../../../../../../../../../actions/contactDetailsActions';
import {resetCommentToAddContactSearchResult} from "../../../../../../../../../actions/contactActions";
import {parseContactOnCommentToAdd} from "../../../../../../../../../actions/commentActions";
import MsgCommentBar from "./components/msg-comment-bar";
import './index.css';

function ContactContent (props) {

    const { t } = useTranslation();

    const {
        findComments,
        contactContent,
        setContactContent,
        resetCommentToAddContactSearchResult,
        setParseContactOnCommentToAdd,
	    setAddToOtherLabel,
        msgCommentBar
    } = props;

    const handleClick = (e) => {
        setContactContent(e.currentTarget.dataset.id);
        resetCommentToAddContactSearchResult();
        setParseContactOnCommentToAdd(null);
	    setAddToOtherLabel(false);
    };

    useEffect(() => {
        if(findComments && findComments.commentResponses.length > 0){
	        setContactContent('comments')
        } else {
	        setContactContent('contact-details')
        }
    }, [findComments, setContactContent]);

    return (
        <div className="contact-content">
            {
                msgCommentBar.length > 0 && <MsgCommentBar/>
            }
            <div className="d-flex">
                <ul className="nav nav-tabs">
                    <li className="nav-item">
                        <button
                            onClick={handleClick}
                            data-id="comments"
                            className={`nav-link${contactContent === "comments" ? ' active' : ''}`}
                        >
                            {t("textComments")}
                            <span
                                className="comment-count ml-1"
                                style={findComments ? findComments.commentResponses.length > 0 ? {color: '#4CBEA3', fontWeight: 'bold'} : null : null}
                            >
                                ({findComments ? findComments.commentResponses.length : '0'})
                            </span>
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            onClick={handleClick}
                            data-id="contact-details"
                            className={`nav-link${contactContent === "contact-details" ? ' active' : ''}`}
                        >
                            {t("contactDetails")}
                        </button>
                    </li>
                    <li className="nav-item">
                        <button
                            onClick={handleClick}
                            data-id="sharing-settings"
                            className={`nav-link${contactContent === "sharing-settings" ? ' active' : ''}`}
                        >
                            {t("textContactContent1")}
                        </button>
                    </li>
                </ul>
            </div>
            {contactContent === "comments" && <CommentsList/>}
            {contactContent === "contact-details" && <ContactDetails/>}
            {contactContent === "sharing-settings" && <SharingSettings/>}
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        findComments: state.commentReducer.findComments,
        contactContent: state.contactDetailsReducer.contactContent,
        msgCommentBar: state.msgBarReducer.msgCommentBar
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setContactContent : (string) => {
            dispatch(contactContent(string))
        },
        resetCommentToAddContactSearchResult : () => {
            dispatch(resetCommentToAddContactSearchResult())
        },
        setParseContactOnCommentToAdd : (array) => {
            dispatch(parseContactOnCommentToAdd(array))
        },
        setAddToOtherLabel: (boolean) => {
		    dispatch(addToOtherLabel(boolean))
	    }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactContent);